export const COTIZACION_FORM = {
    name: "",
    email: "",
    phone: "",
    service: "",
    address: "",
    message: ""
};